module.exports = __webpack_public_path__ + "static/media/suiviPac.444644f6.svg";